<h5 class="mb-0 text-dark ct2-semibold">
  <ng-content></ng-content>
</h5>
